import React from 'react';
import { Control } from 'react-hook-form';
import { FormTextarea } from '../components/shared/FormTextarea';
import { FormInput } from '../components/shared/FormInput';
import { OnboardingData } from '../types';

interface Step6OnlinePresenceProps {
  control: Control<OnboardingData>;
}

const Step6OnlinePresence: React.FC<Step6OnlinePresenceProps> = ({ control }) => {
  return (
    <div className="space-y-3">
      {/* Question 1: Website manager */}
      <div>
        <FormInput
          name="step6_onlinePresence.websiteManager"
          control={control}
          label="Who makes the changes on the website?"
          placeholder="Enter the name or role of the person who manages website updates..."
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 2: Brand voice */}
      <div>
        <FormTextarea
          name="step6_onlinePresence.brandVoice"
          control={control}
          label="What is the voice or personality of your community?"
          placeholder="Describe your brand's communication style and personality..."
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 3: Acquisition channels */}
      <div>
        <FormTextarea
          name="step6_onlinePresence.acquisitionChannels"
          control={control}
          label="Acquisition channels and campaigns — Do you have a newsletter, blog, social channels? Where do you think your community engages with you most?"
          placeholder="Describe all the ways people find and interact with your brand..."
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 4: Sales cycle */}
      <div>
        <FormTextarea
          name="step6_onlinePresence.salesCycle"
          control={control}
          label="What does the sales cycle look like? Do people buy from you mostly at events, or do they want to see more from your website?"
          placeholder="Describe how customers typically discover, consider, and purchase from you..."
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 5: Upload content */}
      {/* <div>
        <FileUploader
          name="step6_onlinePresence.uploadedFiles"
          control={control}
          label="Do you have existing content anywhere else besides the website (PDF, sales brochure, etc.)?"
          accept=".pdf,.doc,.docx,.txt"
          maxSize={10 * 1024 * 1024} // 10MB
          multiple={true}
        />
      </div> */}

      {/* Question 6: Team size */}
      <div>
        <FormInput
          name="step6_onlinePresence.teamSize"
          control={control}
          label="How big is your team: marketing, content, website?"
          placeholder="e.g., 2 people - 1 marketing, 1 content writer..."
          rules={{ required: 'This field is required' }}
        />
      </div>

      {/* Question 7: Content capacity */}
      <div>
        <FormTextarea
          name="step6_onlinePresence.contentCapacity"
          control={control}
          label="What's your capacity to produce new content?"
          placeholder="e.g., 2 blog posts per month, 1 video per quarter..."
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>
    </div>
  );
};

export { Step6OnlinePresence };
